<section class="chat-box">
  <!-- toggle chat box btn -->
  <pwj-button
    class="chat-box__btn"
    buttonClasses="!h-40 !w-40"
    [ngClass]="{ '!hidden': isChatOpened }"
    icon="message-dots"
    [iconReversePosition]="true"
    iconClasses="absolute -ml-8 left-5 !text-3xl"
    size="large"
    [withBadge]="notifications && notifications.length > 0"
    variant="primary"
    [noContentButton]="true"
    (click)="toggleChatBox()">
  </pwj-button>
  <!-- chat box -->
  <div
    class="chat-box__page"
    [ngClass]="{ 'chat-box__page--show': isChatOpened }">
    <!-- chat page header -->
    <pwj-chat-header class="chat-box__header"></pwj-chat-header>
    <!-- chat page messages container -->
    <pwj-chat-messages-container
      class="chat-box__body"></pwj-chat-messages-container>
  </div>
</section>
